import config from "./_apiConfig/apiConfig";
import { performRequest, apiEndPoints, methodType } from "./_apiConfig";
import { postFormWithPerFilePasswordPrompt } from "./pdf_upload";

// A ticket's attachments are sent in one request, so we use the per-file
// password flow: each password-protected PDF attachment is prompted for
// independently and unlocked server-side. Returns the raw success body or
// { success: false, error }.
export const createSupportTicketRequest = async (formData) => {
  return postFormWithPerFilePasswordPrompt(apiEndPoints.supportTickets, formData);
};

export const fetchSupportTicketsRequest = async (loanId) => {
  const url =
    config.API_BASE_URL +
    `${apiEndPoints.supportTickets}?loan=${loanId}`;
  try {
    const response = await performRequest(
      methodType.GET,
      url,
      null, // no body for GET
      true, // auth required
      false // not multipart
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchSupportTicketDetailsRequest = async (ticketId) => {
  const url =
    config.API_BASE_URL + `${apiEndPoints.supportTickets}${ticketId}/`;

  return performRequest(methodType.GET, url, null, true, false);
};

export const fetchSupportTicketSummary = async (loanId) => {
  const url =
    config.API_BASE_URL +
    `${apiEndPoints.supportTicketSummary}?loan=${loanId}`;

  return performRequest(
    methodType.GET,
    url,
    null,
    true,
    false
  );
};